import { Component, OnInit, ViewChild } from '@angular/core';
import { GastroPayService } from '@app/gastro-pay/gastro-pay.service';
import { Subscription, Subject } from 'rxjs';
import { SocketService } from '@app/socket.service';
import { MatSnackBar } from '@angular/material';
import { ConfirmModalComponent } from '@app/shared/confirm-modal/confirm-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientResolverService } from '@app/core/client-resolver.service';
import { CredentialsService } from '@app/core/authentication/credentials.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { filter } from 'rxjs/operators';

import moment from 'moment';
moment.locale('de');

@Component({
  selector: 'app-affiliate',
  templateUrl: './affiliate.component.html',
  styleUrls: ['./affiliate.component.scss']
})
export class AffiliateComponent implements OnInit {
  csvOptions: any = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: false,
    headers: ['ID', 'Datum', 'Uhrzeit', 'Besteller', 'Betrag', 'Gebühr', 'Zahlart', 'Typ', 'Status', 'Kontostand'],
    showTitle: false,
    title: '',
    useBom: false,
    removeNewLines: true,
    keys: [
      'id',
      'dateFormatted',
      'timeFormatted',
      'person',
      'subtotal',
      'commissionFee',
      'paymentMethodText',
      'typeText',
      'statusText',
      'balance'
    ]
  };

  @ViewChild(DatatableComponent, { static: false }) table: DatatableComponent;

  allOrders: any[] = [];
  allOrdersCopy: any[] = [];
  filterFrom: string = '';
  filterTo: string = '';
  now: any = new Date();
  filterBy: string = '';

  pendingOrders: any;
  finishedOrders: any;
  inprogressOrders: any;
  currentDate = new Date();
  tableLimit: number = 1;
  filterStats: any = {
    orders: {
      count: 0,
      total: 0,
      cash: 0,
      gastropay: 0,
      online: 0,
      commission: 0
    }
  };
  stats: any = {
    orders: {
      total: 0,
      yesterday: 0,
      today: 0
    },
    balance: {
      total: 0
    },
    sum: {
      total: 0,
      yesterday: 0,
      today: 0
    }
  };
  dates: any = {
    from: '',
    to: ''
  };
  pushedPayouts: any[] = [];
  pushedOrders: any[] = [];
  affiliateClients: any[] = [];

  creds: any;
  loading: boolean = true;

  private _ordersSub: Subscription;
  private ngUnsubscribe: Subject<any> = new Subject();

  constructor(
    private gastropayService: GastroPayService,
    private socketService: SocketService,
    private snackBar: MatSnackBar,
    private modalService: NgbModal,
    private clientResolver: ClientResolverService,
    private credentialsService: CredentialsService
  ) {}

  ngOnInit() {
    this.creds = this.credentialsService.getCredentials();
    this.getOrders(true); //true
    this.getStats();

    const audio = new Audio();
    if (this.clientResolver.client.gastropaySettings) {
      audio.src = '/assets/sound/' + this.clientResolver.client.gastropaySettings.notificationSound + '.wav';
    } else {
      audio.src = '/assets/sound/bell.wav';
    }
    audio.load();

    // Get socket messages
    this._ordersSub = this.socketService.newOrder.takeUntil(this.ngUnsubscribe).subscribe((res: any) => {
      audio.play();
      this.snackBar.open('Neue Bestellung eingetroffen', '', {
        duration: 2000,
        panelClass: ['snackbar-info']
      });
      this.getOrders(true);
      this.getStats();
    });
  }

  getStats() {
    this.gastropayService
      .getShortStats()
      .takeUntil(this.ngUnsubscribe)
      .subscribe(stats => {
        this.stats = stats;
      });
  }

  getOrders(initialStart: boolean = false) {
    // console.log(144, this.clientResolver.client.ownerId);
    this.pushedOrders = [];
    this.allOrders = [];
    this.pendingOrders = [];
    this.finishedOrders = [];
    this.inprogressOrders = [];

    if (initialStart) {
      this.dates.to = moment().format('YYYY-MM-DD');
      this.dates.from = moment()
        .subtract(6, 'days')
        .format('YYYY-MM-DD');

      if (this.creds.id && this.creds.id > 0) {
        this.gastropayService
          // .getAffiliates(this.creds.id)
          .getAffiliates(this.clientResolver.client.ownerId)
          .takeUntil(this.ngUnsubscribe)
          .subscribe(res => {
            this.affiliateClients = res || [];
            console.log('affiliateClients', this.affiliateClients);
            this.getOwnCashOrders(initialStart);
          });
      } else {
        console.log('no affiliates found!');
        this.getOwnCashOrders(initialStart);
      }
    } else {
      this.getOwnCashOrders(initialStart);
    }
    //
  }

  getOwnCashOrders(initialStart: boolean = false) {
    this.gastropayService
      .getOwnCashOrders(this.affiliateClients, this.dates.from, this.dates.to)
      .takeUntil(this.ngUnsubscribe)
      .subscribe(res => {
        res.forEach((order: any) => {
          //if (order.paymentMethod === 'cash') {
          if (!order.desiredTime) {
            order.desiredTime = order.createdAt;
          }
          this.pushOrder(order);
          //}
        });
        console.log(' ende getOwnCashOrders: this.allOrders', this.allOrders);

        this.getOwnTransactionOrders(initialStart);
      });
  }

  getOwnTransactionOrders(initialStart: boolean = false) {
    console.log(200, this.dates);

    this.gastropayService
      .getOwnTransactionOrders(this.affiliateClients, this.dates.from, this.dates.to)
      .takeUntil(this.ngUnsubscribe)
      .subscribe(res => {
        console.log('ende getOwnTransactionOrders', res);

        res.orders.forEach((order: any) => {
          if (order.paymentTransaction) {
            if (order.paymentTransaction.gastropayOrders) {
              order.paymentTransaction.gastropayOrders.paymentTransaction = { ...order.paymentTransaction };
              if (!order.paymentTransaction.gastropayOrders.desiredTime) {
                order.paymentTransaction.gastropayOrders.desiredTime =
                  order.paymentTransaction.gastropayOrders.createdAt;
              }
              delete order.paymentTransaction.gastropayOrders.paymentTransaction.gastropayOrders;
            }
            if (order.paymentTransaction.gastropayOrders && order.type != 'refund') {
              this.pushOrder(order.paymentTransaction.gastropayOrders, order.balance);
            } else {
              if (order.type == 'refund') {
                this.pushOrder(res.refundOrders[order.foreignId], order.balance);
              } else {
                if (order.type == 'payout') {
                  if (!this.pushedPayouts.includes(order.createdAt)) {
                    this.allOrders.push({
                      id: order.payoutId,
                      createdAt: order.createdAt,
                      firstName: '',
                      lastName: 'Auszahlung',
                      subtotal: order.value,
                      deliveryFee: 0,
                      commissionFee: 0,
                      paymentMethod: '',
                      type: 'payout',
                      status: 'confirmed',
                      balance: 0.00001
                    });
                    this.pushedPayouts.push(order.createdAt);
                  }
                } else {
                  // console.log(order.type, order);
                }
              }
            }
          }
        });
        console.log(255, this.allOrders);

        this.allOrders = [...this.allOrders];
        this.tableLimit = 50;
        this.loading = false;
        this.getFilterStats();

        if (this.filterBy !== '' && this.filterBy) {
          this.filterOrdersBy('client', this.filterBy);
        }
        //if (initialStart) {
        //  this.filterDates('from', { value: { _d: this.dates.from } });
        //}
      });
  }

  pushOrder(order: any, balance: number = 0) {
    if (!this.pushedOrders.includes(order.id)) {
      if (!order.paymentId) {
        order.paymentId = '';
      }
      if (!order.zipCode) {
        order.zipCode = '';
      }

      if (order.gastropayTransaction !== undefined && order.gastropayTransaction !== null) {
        order.balance = order.gastropayTransaction.balance;
      } else {
        order.balance = balance;
      }
      if (order.firstName || order.lastName) {
        order.person = order.firstName + ' ' + order.lastName;
      } else {
        order.person = '';
      }
      order.paymentMethodText = '';
      if (order.paymentMethod === 'cash') {
        order.paymentMethodText = 'Bar';
      }
      if (order.paymentMethod === 'gastropay') {
        order.paymentMethodText = 'Gastropay';
      }
      if (order.paymentMethod === 'online' && order.paymentTransaction) {
        order.paymentMethodText = order.paymentTransaction.paymentMethod;
      }
      if (order.paymentMethodText === 'paypal') {
        order.paymentMethodText = 'PayPal';
      }
      if (order.paymentMethodText === 'creditcard') {
        order.paymentMethodText = 'Kreditkarte';
      }

      order.typeText = '';
      if (order.type === 'delivery') {
        order.typeText = 'Lieferung';
      }
      if (order.type === 'takeaway') {
        order.typeText = 'Abholung';
      }

      order.statusText = '';
      if (order.type === 'pending') {
        order.statusText = 'Ausstehend';
      }
      if (order.type === 'confirmed') {
        order.statusText = 'Fertig';
      }
      if (order.type === 'canceled') {
        order.statusText = 'Storniert';
      }

      let date = new Date(order.createdAt);
      const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: '2-digit', day: '2-digit' });
      const [{ value: month }, , { value: day }, , { value: year }] = dateTimeFormat.formatToParts(date);

      order.dateFormatted = `${day}.${month}.${year}`;
      order.timeFormatted =
        order.createdAt.split(' ')[1].split(':')[0] + ':' + order.createdAt.split(' ')[1].split(':')[1];

      if (order.status === 'pending' && !order.deliveryTime && order.deliveryTime !== 0) {
        this.pendingOrders.push(order);
      }
      if (order.status === 'pending' && (order.deliveryTime || order.deliveryTime === 0)) {
        this.inprogressOrders.push(order);
      }
      if (order.status === 'confirmed' || order.status === 'canceled') {
        this.finishedOrders.push(order);
      }
      this.allOrders.push(order);
      this.pushedOrders.push(order.id);
    }
  }

  /*
    exportArrayToCsv() {
      this.csvAllOrders = [];

      this.allOrders.forEach((row: any) => {
        this.csvAllOrders.push({
          id: row.id,
          date: row.createdAt,
          status: row.status,
          type: row.type,
          paymentMethod: row.paymentMethod,
          paymentId: row.paymentId,
          subtotal: row.subtotal,
          deliveryFee: row.deliveryFee,
          commissionFee: row.commissionFee,
          balance: row.gastropayTransaction,
          firstName: row.firstName,
          lastName: row.lastName,
          street: row.street,
          zipCode: row.zipCode,
          city: row.city,
          email: row.email,
          phone: row.phone,
        });
      }, this);
    }
    */
  arrayToCSV(objArray: any = []) {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    let str =
      `${Object.keys(array[0])
        .map(value => `"${value}"`)
        .join(',')}` + '\r\n';

    return array.reduce((str: any, next: any) => {
      str +=
        `${Object.values(next)
          .map(value => `"${value}"`)
          .join(',')}` + '\r\n';
      return str;
    }, str);
  }

  filterDates(filterBy: string, event: any) {
    this.loading = true;
    let filterDate = moment(event.value._d).format('YYYY-MM-DD');

    if (filterDate) {
      this.filterOrdersBy(filterBy, filterDate);
    }
  }

  getFilterStats() {
    this.filterStats.orders.count = 0;
    this.filterStats.orders.total = 0;
    this.filterStats.orders.commission = 0;
    this.filterStats.orders.cash = 0;
    this.filterStats.orders.gastropay = 0;
    this.filterStats.orders.online = 0;

    this.allOrders.forEach((order: any) => {
      if (order.type != 'payout' && order.status != 'canceled' && order.status != 'paying') {
        if (order.type === 'confirmed') {
          order.statusText = 'Fertig';
        }
        this.filterStats.orders.count++;
        this.filterStats.orders.total = this.filterStats.orders.total + this.returnPrice(order.subtotal);
        this.filterStats.orders.commission = this.filterStats.orders.commission + this.returnPrice(order.commissionFee);

        if (order.paymentMethod === 'cash') {
          this.filterStats.orders.cash = this.filterStats.orders.cash + this.returnPrice(order.subtotal);
        }
        if (order.paymentMethod === 'gastropay') {
          this.filterStats.orders.gastropay = this.filterStats.orders.gastropay + this.returnPrice(order.subtotal);
        }
        if (order.paymentMethod === 'online') {
          this.filterStats.orders.online = this.filterStats.orders.online + this.returnPrice(order.subtotal);
        }
      }
    });
    //console.log('getFilterStats',this.allOrders);
  }

  filterOrdersBy(filterBy: string = '', filterVal: string = '') {
    switch (filterBy) {
      case 'from':
        this.dates.from = filterVal;
        this.getOrders(false);
        /*
        this.dates.from = filterVal;
        this.filterFrom = filterVal;
        //console.log('filterVal', filterVal);

        this.allOrdersCopy = [...this.allOrders];
        this.allOrders = this.allOrdersCopy.filter(function(order: any) {
          if (
            (order.createdAt >= this.filterFrom || this.filterFrom == '') &&
            (order.createdAt <= this.filterTo || this.filterTo == '')
          ) {
            return order;
          }
        }, this);
        this.allOrders = [...this.allOrders];
        if (this.table) {
          this.table.offset = 0;
        }
        */

        break;

      case 'to':
        this.dates.to = filterVal;
        this.getOrders(false);
        /*
        this.dates.to = filterVal;
        this.filterTo = filterVal;
        this.allOrdersCopy = [...this.allOrders];
        this.allOrders = this.allOrdersCopy.filter(function(order: any) {
          if (
            (order.createdAt >= this.filterFrom || this.filterFrom == '') &&
            (order.createdAt <= this.filterTo || this.filterTo == '')
          ) {
            return order;
          }
        }, this);
        this.allOrders = [...this.allOrders];
        if (this.table) {
          this.table.offset = 0;
        }
        */
        break;

      case 'client':
        this.filterBy = filterVal;
        this.allOrdersCopy = [...this.allOrders];
        this.allOrders = this.allOrdersCopy.filter(function(order: any) {
          if (
            order.clientId == filterVal &&
            (order.createdAt >= this.dates.from || this.dates.from == '') &&
            (order.createdAt <= this.dates.to || this.dates.to == '')
          ) {
            return order;
          }
        }, this);
        this.allOrders = [...this.allOrders];
        if (this.table) {
          this.table.offset = 0;
        }
        this.getFilterStats();
        break;

      default:
        this.filterBy = '';
        this.allOrders = [...this.allOrdersCopy];
        this.allOrdersCopy = [];
        if (this.table) {
          this.table.offset = 0;
        }
        this.getFilterStats();
        break;
    }
  }
  setDates(type: string) {
    if (type == 'today') {
      this.filterDates('from', { value: { _d: new Date() } });
      this.filterDates('to', { value: { _d: new Date() } });
    }
    if (type == 'yesterday') {
      let yesterday: Date = new Date();
      yesterday.setDate(yesterday.getDate() - 1);

      this.filterDates('from', { value: { _d: yesterday } });
      this.filterDates('to', { value: { _d: yesterday } });
    }
    if (type == 'thisWeek') {
      const date = new Date();
      this.filterDates('from', { value: { _d: this.getMonday(date) } });

      const date2 = new Date();
      this.filterDates('to', { value: { _d: this.getSunday(date2) } });
    }
    if (type == 'lastSeven') {
      let date = new Date();
      date.setDate(date.getDate() - 6);
      this.filterDates('from', { value: { _d: date } });
      date.setDate(date.getDate() + 6);
      this.filterDates('to', { value: { _d: date } });
    }
    if (type == 'lastWeek') {
      let date = new Date();
      date.setDate(date.getDate() - 7);
      this.filterDates('from', { value: { _d: this.getMonday(date) } });
      this.filterDates('to', { value: { _d: this.getSunday(date) } });
    }
    if (type == 'lastMonth') {
      let date = new Date();
      let startDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
      let endDate = new Date(date.getFullYear(), date.getMonth(), 1);
      endDate.setDate(endDate.getDate() - 1);

      this.filterDates('from', { value: { _d: startDate } });
      this.filterDates('to', { value: { _d: endDate } });
    }
    if (type == 'thisMonth') {
      let date = new Date();
      let startDate = new Date(date.getFullYear(), date.getMonth(), 1);
      let endDate = new Date(date.getFullYear(), date.getMonth() + 1, 1);
      endDate.setDate(endDate.getDate() - 1);

      this.filterDates('from', { value: { _d: startDate } });
      this.filterDates('to', { value: { _d: endDate } });
    }
  }
  getMonday(d: any) {
    d = new Date(d);
    var day = d.getDay(),
      diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    return new Date(d.setDate(diff));
  }
  getSunday(d: any) {
    d = new Date(d);
    const s = moment(d).day(7);
    return s;
  }

  returnPrice(price: any) {
    if (typeof price == 'string') {
      return parseFloat(price.replace(',', '.'));
    } else {
      return price || 0;
    }
  }
}
